<template>
  <div class="ticket-container py-5 mt-5 mb-5">
    <div class="container">
      <!-- Cotația Euro -->
      <section class="euro-rate text-center mb-4">
        <div class="alert alert-info">
          <i class="fa fa-euro-sign"></i> {{ $t("currency.rate") }}: <strong>{{ euroRate }} RON / EUR</strong>
        </div>
      </section>
      <section class="ticket-alert text-center mb-4">
  <div class="alert alert-warning">
    <i class="fa fa-exclamation-triangle"></i> {{ $t("tickets.alert") }}
  </div>
</section>

<!-- Selectare Client -->
<section class="client-select text-center mb-4">
  <div class="card p-3 shadow-sm">
    <h5 class="text-primary">
      <i class="fa fa-user me-2"></i> {{ $t("cart.selectClient") }}
    </h5>

    <!-- Dacă există clienți -->
    <div v-if="clients.length">
<select v-model="selectedClient" class="form-control mt-2">
<option disabled value="">{{ $t("cart.selectClient") }}</option>

  <option v-for="client in clients" :key="client.id" :value="client">
    {{ client.denumire }} ({{ client.cod_fiscal || $t("cart.noCui") }})
  </option>
</select>

    </div>

    <!-- Dacă nu există clienți -->
    <div v-else class="alert alert-warning mt-3">
      <i class="fa fa-info-circle me-1"></i> {{ $t("cart.noClients") }}
    </div>
  </div>
</section>

      <div class="row">
        <!-- Secțiunea de selectare bilete -->
        <div class="col-md-6 mb-3">
          <section>
            <h2 class="mb-4"><i class="fa fa-ticket"></i> {{ $t("tickets.buy") }}</h2>
            <div v-if="products.length" class="card p-4 shadow-sm">
              <div class="form-group mb-3">
                <label class="fw-bold text-primary"><i class="fa fa-list"></i> {{ $t("tickets.selectType") }}</label>
                <select v-model="selectedProduct" class="form-control">
                  <option v-for="product in products" :key="product.id" :value="product">
                    {{ getProductName(product.name) }} - {{ Number(product.price_tva_included).toFixed(2) }} EUR 
                  </option>
                </select>
              </div>

              <div class="form-group mb-3">
                  <small class="text-muted d-block mt-1">
  <i class="fa fa-info-circle me-1"></i> {{ $t("tickets.alert2") }}
</small>

                <label class="fw-bold text-primary"><i class="fa fa-users"></i> {{ $t("tickets.numPersons") }}</label>
                <input type="number" v-model.number="persons" min="1" class="form-control" />
              </div>

              <!-- Campul Nr. Mașina apare doar dacă produsul NU este "Pasager" -->
              <div v-if="selectedProduct && !selectedProduct.name.includes('Pasager')" class="form-group mb-3">
                <label class="fw-bold text-primary"><i class="fa fa-car"></i> {{ $t("tickets.carNumber") }}</label>
                <input 
                  type="text" 
                  v-model="nrMasina" 
                  class="form-control text-uppercase" 
                  :placeholder="$t('tickets.carNumberPlaceholder')" 
                  @input="nrMasina = nrMasina.toUpperCase()"
                />
              </div>
<div class="total-price mt-3 p-3 bg-light text-center rounded">
  <h5 class="mb-1 text-primary">
    <i class="fa fa-money-bill-wave"></i> {{ $t("cart.total") }}
  </h5>
  <strong class="text-primary">
    {{ totalCartEUR }} EUR ({{ totalCartRON }} RON)
  </strong>
</div>


<button 
  class="btn btn-primary mt-3 w-100" 
  @click="addToCart" 
  :disabled="!selectedProduct || (!nrMasina && needsCarNumber())">
  <i class="fa fa-cart-plus"></i> {{ $t("tickets.addToCart") }}
</button>
            </div>

            <div v-else>
              <p class="text-center">⏳ {{ $t("tickets.noTickets") }}</p>
            </div>
          </section>
        </div>

        <!-- Secțiunea coșului de cumpărături -->
        <div class="col-md-6">
          <section>
            <h2 class="mb-4"><i class="fa fa-shopping-cart"></i> {{ $t("cart.title") }}</h2>

            <div v-if="cart.length" class="cart-container p-4 bg-light rounded shadow-sm">
              <ul class="list-group">
                <li v-for="(item, index) in cart" :key="index" class="list-group-item d-flex align-items-center">
                  
                  <!-- Imaginea produsului -->
                  <img :src="getProductImage(item.product.image_url)" 
                      :alt="getProductName(item.product.name)" 
                      class="cart-item-image me-3" />

                  <div class="cart-item-details">
                    <strong>{{ getProductName(item.product.name) }}</strong> <br />
                    <span>{{ $t("cart.numPersons") }}: {{ item.persons }}</span> <br />
                    <span v-if="item.nrMasina">{{ $t("cart.carNumber") }}: {{ item.nrMasina }}</span>
                  </div>

                  <div class="cart-item-price text-end">
                    <strong>{{ item.totalEUR }} EUR</strong> <br />
                    <span class="text-muted">{{ item.totalRON }} RON</span>
                  </div>

                  <button class="btn btn-danger btn-sm ms-3" @click="removeFromCart(index)">
                    <i class="fa fa-trash"></i>
                  </button>
                </li>
              </ul>

              <div class="form-check mt-3">
  <input type="checkbox" id="agreeTerms" v-model="agreedToTerms" class="form-check-input" />
  <label for="agreeTerms" class="form-check-label">
    {{ $t("cart.noRefund") }}
    <span class="d-block mt-2">
      <a 
        href="/termeni" 
        target="_blank" 
        rel="noopener noreferrer" 
        class="text-decoration-none text-primary fw-bold"
      >
        <i class="fa fa-link me-1"></i>
        {{ $t("cart.readMore") }}
      </a>
    </span>
  </label>
</div>


              <!-- Precizare despre valabilitatea biletelor -->
<!-- Precizare despre valabilitatea biletelor -->
<p class="text-danger mt-2"><i class="fa fa-info-circle"></i> {{ $t("cart.validity") }}</p>

<!-- ✅ Mesaj nou adăugat aici -->
<p class="text-muted mt-3 small">
  <i class="fa fa-info-circle me-1"></i>
  {{ $t("cart.verifyInfo") }}
</p>

<!-- Buton pentru finalizarea comenzii -->
<button 
  class="btn btn-warning mt-3 w-100" 
  @click="payWithBTPay" 
  :disabled="!agreedToTerms || !selectedClient"
>
  <i class="fa fa-credit-card"></i> Plătește cu BT Pay
</button>


            </div>

            <div v-else>
              <p class="text-center">{{ $t("cart.empty") }}</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>


<style scoped>
.ticket-container {
  max-width: 900px;
  margin: auto;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

h2 {
  font-weight: bold;
  color: #0056b3;
}

.card {
  border: 1px solid #ddd;
  border-radius: 10px;
  background: white;
}

.form-group label {
  font-weight: bold;
}

.total-price {
  font-size: 1.4rem;
  font-weight: bold;
}

.total-price .text-warning {
  font-size: 1.6rem;
}

.btn-success {
  font-size: 1.2rem;
  padding: 10px;
}

.cart-item-image {
  width: 50px;
  height: 50px;
  object-fit: contain;
}
.cart-item-details {
  flex-grow: 1;
}
.cart-item-price {
  min-width: 80px;
}
.text-uppercase {
  text-transform: uppercase;
}

</style>

<script>
export default {
  data() {
    return {
      products: [],
      selectedProduct: null,
      persons: 1,
      nrMasina: "",
      selectedClient: null,
      clients: [],
      euroRate: null,
      passengerPrice: 0,
      cart: [],
      agreedToTerms: false,
    };
  },computed: {
  totalPriceEUR() {
    if (!this.selectedProduct) return "0.00";
    let basePriceEUR = Number(this.selectedProduct.price_tva_included) || 0;
    let extraPassengerPriceEUR = this.selectedProduct.name.includes("Pasager")
      ? (this.persons - 1) * (Number(this.passengerPrice) || 0)
      : this.persons * (Number(this.passengerPrice) || 0);
    let totalEUR = basePriceEUR + extraPassengerPriceEUR;
    return totalEUR.toFixed(2);
  },
  totalPriceRON() {
    return (Number(this.totalPriceEUR) * this.euroRate).toFixed(2);
  },
totalCartEUR() {
  return this.cart.reduce((sum, item) => sum + parseFloat(item.totalEUR || 0), 0).toFixed(2);
},
totalCartRON() {
  return this.cart.reduce((sum, item) => sum + parseFloat(item.totalRON || 0), 0).toFixed(2);
}

},

  methods: {
    getProductImage(imageUrl) {
      return imageUrl ? `https://api.feribot-eurobac.ro${imageUrl}` : "/default-image.png";
    },
    needsCarNumber() {
      return this.selectedProduct && !this.selectedProduct.name.includes("Pasager");
    },
    getProductName(name) {
      const translated = this.$t(`products.${name}`);
      return translated !== `products.${name}` ? translated : name;
    },
convertedToRON(priceEUR) {
  if (!this.euroRate || !priceEUR) return "0.00";

  const Decimal = (val) => parseFloat(val.toFixed(10));
  const ROUND = (val, decimals) => parseFloat(val.toFixed(decimals));

  const exchangeRate = Decimal(this.euroRate);
  const tvaRate = 0.21;

  const price_tva_ron = Decimal(priceEUR * exchangeRate);
  const price_ftva = ROUND(price_tva_ron / (1 + tvaRate), 2);  // ✅
  const tva_val = ROUND(price_ftva * tvaRate, 2);              // ✅
  const total = ROUND(price_ftva + tva_val, 2);                // ✅


  return total.toFixed(2);
}



,
    async fetchClients() {
      try {
        const res = await fetch("https://api.feribot-eurobac.ro/client/api/list_clients/", { credentials: "include" });
        const data = await res.json();
        this.clients = data.clients || [];
        if (!this.selectedClient && this.clients.length) {
          this.selectedClient = this.clients[0];
        }
      } catch (err) {
        console.error("Eroare la obținerea clienților:", err);
      }
    },
    async fetchProducts() {
      try {
        const res = await fetch("https://api.feribot-eurobac.ro/client/api/products/");
        const data = await res.json();
        this.products = Array.isArray(data) ? data : [];

        const passenger = this.products.find(p => p.name.includes("Pasager"));
        if (passenger) {
          this.passengerPrice = passenger.price_tva_included;
        }
      } catch (err) {
        console.error("Eroare la obținerea produselor:", err);
      }
    },
    async fetchCart() {
  try {
    const res = await fetch("https://api.feribot-eurobac.ro/client/api/get-cart/", {
      credentials: "include"
    });
    const result = await res.json();
    if (result.items) {
      this.cart = result.items;
    }
    if (result.exchange_rate) {
      this.euroRate = result.exchange_rate;
    }
  } catch (err) {
    console.error("Eroare la încărcarea coșului:", err);
  }
},

async addToCart() {
  const payload = {
    product_id: this.selectedProduct.id,
    persons: this.persons,
    nr_masina: this.nrMasina || null,
  };

  try {
    const res = await fetch("https://api.feribot-eurobac.ro/client/api/preview-ticket/", {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const result = await res.json();
    if (result.items) {
      this.cart = result.items;
    }
  } catch (err) {
    console.error("Eroare la preview-ticket:", err);
  }
},
async removeFromCart(index) {
  const itemId = this.cart[index].id;
  try {
    const res = await fetch(`https://api.feribot-eurobac.ro/client/api/remove-cart-item/`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ item_id: itemId }),
    });
    const result = await res.json();
    if (result.items) {
      this.cart = result.items;
    }
  } catch (err) {
    console.error("Eroare la ștergerea itemului:", err);
  }
}
,
async payWithBTPay() {
  if (!this.cart.length || !this.selectedClient) return;

  try {
    const res = await fetch("https://api.feribot-eurobac.ro/client/api/bt-pay", {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        client_id: this.selectedClient.id  // 🔥 trimitem clientul selectat!
      }),
    });
    const result = await res.json();
    if (result.success && result.payment_url) {
      window.location.href = result.payment_url;
    } else {
      this.$router.push("/plata-esuata");
    }
  } catch (err) {
    console.error("Eroare BT Pay:", err);
    this.$router.push("/plata-esuata");
  }
}

,
    async purchaseTickets() {
      if (!this.cart.length) return;

      try {
        const res = await fetch("https://api.feribot-eurobac.ro/client/api/purchase-ticket/", {
          method: "POST",
            credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            tickets: this.cart,
            client_id: this.selectedClient?.id || null,
          }),
        });

        const result = await res.json();
        if (result.success) {
          window.location.href = result.payment_url;
        } else {
          alert("Eroare la inițierea plății.");
        }
      } catch (err) {
        console.error("Eroare la finalizare comenzii:", err);
      }
    },
  },
mounted() {
  this.fetchProducts();
  this.fetchClients();
  this.fetchCart();
}
,watch: {
  selectedProduct() {
    if (!this.needsCarNumber()) {
      this.nrMasina = "";  // 🔄 Golește doar dacă nu e nevoie
    }
  }
}

};
</script>
